import BasicRepository from "./basicRepository";
import Client from "../client";
import {
    WorkerPoolResource,
    WorkerPoolsSummaryResource,
    DeploymentTargetResource,
    ResourceCollection,
    WorkerMachineResource,
} from "client/resources";

class WorkerPoolRepository extends BasicRepository<WorkerPoolResource, WorkerPoolResource> {
    constructor(client: Client) {
        super("WorkerPools", client);
    }
    machines(args?: Partial<WorkerPoolsMachinesArgs>): Promise<ResourceCollection<WorkerMachineResource>> {
        return this.client.get<ResourceCollection<WorkerMachineResource>>(args.workerpool.Links["Workers"], args);
    }
    summary(args?: Partial<WorkerPoolsSummaryArgs>) {
        return this.client.get<WorkerPoolsSummaryResource>(this.client.getRootDocument().Links["WorkerPoolsSummary"], args);
    }
    sort(order: string[]) {
        return this.client.put(this.client.getRootDocument().Links["WorkerPoolsSortOrder"], order);
    }
}

export type WorkerPoolsMachinesArgs = {
    workerpool: WorkerPoolResource,
    skip: number,
    take: number,
    partialName: string,
    isDisabled: boolean,
    healthStatuses: string,
    commStyles: string,
};

export type WorkerPoolsSummaryArgs = {
    ids: string,
    partialName: string,
    machinePartialName: string,
    isDisabled: boolean,
    healthStatuses: string,
    commStyles: string,
    hideEmptyWorkerPools: boolean,
};

export default WorkerPoolRepository;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/client/repositories/workerpoolsRepository.ts